/** Locale fixe pour tous les entiers affichés (espace fine insécable entre milliers). */
export const UI_NUMBER_LOCALE = 'fr-FR'

/** Formate un entier pour l’UI — indépendant de la locale navigateur / OS. */
export function formatUiInteger(value: number | string, locale?: string): string {
  const n = typeof value === 'number' ? value : Number(value)
  if (!Number.isFinite(n)) return '0'
  return Math.round(n).toLocaleString(locale ?? UI_NUMBER_LOCALE)
}
